import {SortOrder} from '@netx/core-schema';
import {sortByTime} from './sortByTime';

export const sortByDate = (
	a: Date | string | number,
	b: Date | string | number,
	order: SortOrder = SortOrder.ASCENDING,
) => {
	if (!(a instanceof Date)) a = new Date(a);
	if (!(b instanceof Date)) b = new Date(b);
	return sortByTime(a.getTime(), b.getTime(), order);
};
